import {
  Box,
  Button
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const MotionBtn = motion(Button)

export const CustomMainBox = styled(Box)`
  display: flex;
  direction: row;
  width: calc(100% + 112px);
  margin: 15px auto 0 -56px;
`

const foot = (side, blogType) => {
  if (
    (
      blogType === 'archived'
      && side === 'left'
    )
    || (
      blogType === 'posted'
      && side === 'right'
    )
  ) {
    return {
      content: '""',
      position: 'absolute',
      bottom: -8,
      [side]: '-12px',
      width: '14px',
      height: '58px',
      background: 'var(--tab-bg)',
      clipPath: side === 'left'
        ? 'polygon(100% 50%, 100% 100%, 0 100%)'
        : 'polygon(0 50%, 0 100%, 100% 100%)'
    }
  }

  return {
    content: '""',
    position: 'absolute',
    bottom: 0,
    [side]: '-16px',
    width: '16px',
    height: '16px',
    background: `radial-gradient(circle at ${side === 'left' ? '0' : '100%'} 0, transparent 16px, var(--tab-bg) calc(16px + 0.5px))`
  }
}

export const CustomBtn = styled(MotionBtn)`
  width: calc(33.33% - 16px);
  height: 30px !important;
  min-width: 0px !important;
  border-radius: 17px 17px 0 0 !important;
  padding: 4px 10px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  font-weight: 500 !important;
  position: relative;
  color: transparent !important;

  &::before {
    ${({ blogType }) => foot('left', blogType)}
  }

  &::after {
    ${({ blogType }) => foot('right', blogType)}
  }
`
